import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MiroAuthCallbackRequest } from '@shared/index';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MiroAuthService {
  private http = inject(HttpClient);

  public async authorizeMiro(params: MiroAuthCallbackRequest): Promise<string> {
    try {
      const response = await firstValueFrom(this.http.post<{ state: string }>('/api/callback/miro', params));
      return response.state;
    } catch (error) {
      console.error('Error authorizing Miro:', error);
      throw error;
    }
  }

}
